module.exports = __webpack_public_path__ + "static/img/honor11.b2f948f.png";


//////////////////
// WEBPACK FOOTER
// ./public/aboutusImg/honor11.png
// module id = QwOx
// module chunks = 0